import * as actionTypes from "../ActionTypes";
import { put, call, takeLatest } from "redux-saga/effects";
import * as api from "./CurriculumAPI";
import { actionUpdateGlobalLoaderSagaAction } from "../GlobalLoader/GlobalLoaderAction";

function* curriculumReadRequestSaga(action) {
    yield put(actionUpdateGlobalLoaderSagaAction(true));
    try {
        const payload = action.payload.apiPayloadRequest;
        const response = yield call(api.readCurriculum, payload);
        action.payload.callback(response);
    } catch (err) {
        if (err?.response) {
                    } else {
                    }
    } finally {
        yield put(actionUpdateGlobalLoaderSagaAction(false));
    }
}

function* curriculumHomeReadRequestSaga(action) {
    yield put(actionUpdateGlobalLoaderSagaAction(true));
    try {
        const payload = action.payload.apiPayloadRequest;
        const response = yield call(api.readHomeCurriculum, payload);
        action.payload.callback(response);
    } catch (err) {
        if (err?.response) {
                    } else {
                    }
    } finally {
        yield put(actionUpdateGlobalLoaderSagaAction(false));
    }
}
function* churchCurriculumSaveRequestSaga(action) {
    yield put(actionUpdateGlobalLoaderSagaAction(true));
    try {
      const payload = action.payload.apiPayloadRequest;
      const response = yield call(api.saveChurchCurriculum, payload);
      action.payload.callback(response);
    } catch (err) {
      if (err?.response) {
              } else {
              }
    } finally {
      yield put(actionUpdateGlobalLoaderSagaAction(false));
    }
  }
  function* churchCurriculumDeleteRequestSaga(action) {
    yield put(actionUpdateGlobalLoaderSagaAction(true));
    try {
      const payload = action.payload.apiPayloadRequest;
      const response = yield call(api.deleteChurchCurriculum, payload);
      action.payload.callback(response);
    } catch (err) {
      if (err?.response) {
              } else {
              }
    } finally {
      yield put(actionUpdateGlobalLoaderSagaAction(false));
    }
  }
  function* churchJournalSaveRequestSaga(action) {
    yield put(actionUpdateGlobalLoaderSagaAction(true));
    try {
      const payload = action.payload.apiPayloadRequest;
      const response = yield call(api.saveChurchJournal, payload);
      action.payload.callback(response);
    } catch (err) {
      if (err?.response) {
              } else {
              }
    } finally {
      yield put(actionUpdateGlobalLoaderSagaAction(false));
    }
  }

export default function* CurriculumWatcherSaga() {
    yield takeLatest(
        actionTypes.CURRICULUM_READ_REQUEST,
        curriculumReadRequestSaga
    );

    yield takeLatest(
        actionTypes.CURRICULUM_HOME_READ_REQUEST,
        curriculumHomeReadRequestSaga
    );
    yield takeLatest(
        actionTypes.CHURCH_CURRICULUM_SAVE_REQUEST,
        churchCurriculumSaveRequestSaga
      );
      yield takeLatest(
        actionTypes.CHURCH_CURRICULUM_DELETE_REQUEST,
        churchCurriculumDeleteRequestSaga
      );
      yield takeLatest(
        actionTypes.CHURCH_JOURNAL_SAVE_REQUEST,
        churchJournalSaveRequestSaga
      );
}